module.exports = __webpack_public_path__ + "media/assets/images/claim-places/is-new-claim-icon-8e3f8efb8d2cfd6f9f29e4ceb3332570.svg";